module.exports = __webpack_public_path__ + "media/images/favicon-1a5f58d058ae5d468b130dfb4c684351.ico";